/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const CvSearchSyncHealthDto = {
    Green: 'GREEN',
    Yellow: 'YELLOW',
    Red: 'RED',
    Disabled: 'DISABLED',
    Unknown: 'UNKNOWN',
} as const;

export type CvSearchSyncHealthDto = typeof CvSearchSyncHealthDto[keyof typeof CvSearchSyncHealthDto];



